import { Box } from '@mui/material';
import { LogoSvg } from '@assets/index';
import { colors, spacing, shadows, radii } from '@components/design-system/tokens';
import type { ReactNode } from 'react';

export const TicketContainer = ({ children }: { children?: ReactNode }) => {
  return (
    <Box sx={{
      minHeight: '100dvh',
      backgroundColor: { xs: colors.neutral[0], sm: colors.neutral[100] },
      padding: { xs: `${spacing.md}px`, sm: `${spacing.lg}px` },
      display: 'flex',
      justifyContent: 'center',
    }}>
      <Box sx={{
        width: '100%',
        maxWidth: 560,
        backgroundColor: colors.neutral[0],
        borderRadius: { xs: 0, sm: `${radii.lg}px` },
        boxShadow: { xs: 'none', sm: shadows.card },
        padding: { xs: 0, sm: `${spacing.xl}px` },
        display: 'flex',
        flexDirection: 'column',
        gap: `${spacing.lg}px`,
        height: 'fit-content',
        my: { xs: 0, sm: `${spacing.xl}px` },
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <LogoSvg />
        </Box>
        {children}
      </Box>
    </Box>
  );
};
